module.exports = __webpack_public_path__ + "img/strategy-gantt.2812d193.jpg";